import React from 'react';
export function Table({
  children,
  minWidth = 900
}: {
  children: React.ReactNode;
  minWidth?: number;
}) {
  return <div className="w-full overflow-x-auto" data-id="element-406" data-mp="22drm176exfuu">
      <table className="w-full border-t border-ink-200 text-left text-[13px]" style={{
      minWidth
    }} data-id="element-407" data-mp="22ejiek7u3hm6">
        {children}
      </table>
    </div>;
}
export function THead({
  children
}: {
  children: React.ReactNode;
}) {
  return <thead className="bg-ink-50 text-[11px] font-medium text-ink-500" data-id="element-408" data-mp="2gcrekpx1qewa">{children}</thead>;
}
export function TH({
  children,
  className = '',
  width
}: {
  children?: React.ReactNode;
  className?: string;
  width?: number;
}) {
  return <th scope="col" style={width ? {
    width
  } : undefined} className={`whitespace-nowrap border-b border-r border-ink-200 px-4 py-2 font-medium last:border-r-0 ${className}`} data-id="element-409" data-mp="2q2t1vfhkrta5">
      {children}
    </th>;
}
interface TRProps {
  children: React.ReactNode;
  onClick?: () => void;
  selected?: boolean;
  disabled?: boolean;
}
export function TR({
  children,
  onClick,
  selected,
  disabled
}: TRProps) {
  const interactive = Boolean(onClick) && !disabled;
  return <tr onClick={interactive ? onClick : undefined} className={`border-b border-ink-200 ${selected ? 'bg-brand-50' : disabled ? 'bg-ink-50' : 'bg-white'} ${interactive ? 'cursor-pointer hover:bg-brand-50/50' : ''}`} data-id="element-410" data-mp="2d58a2ahwaq2m">
      {children}
    </tr>;
}
export function TD({
  children,
  className = '',
  colSpan
}: {
  children?: React.ReactNode;
  className?: string;
  colSpan?: number;
}) {
  return <td colSpan={colSpan} className={`border-r border-ink-200 px-4 py-2.5 align-middle text-ink-800 last:border-r-0 ${className}`} data-id="element-411" data-mp="2vyvdgpam0l06">
      {children}
    </td>;
}
export function Checkbox({
  checked,
  onChange,
  disabled,
  label,
  indeterminate
}: {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  label: string;
  indeterminate?: boolean;
}) {
  return <input type="checkbox" checked={checked} disabled={disabled} aria-label={label} ref={el => {
    if (el) el.indeterminate = Boolean(indeterminate) && !checked;
  }} onChange={onChange} onClick={e => e.stopPropagation()} className="h-4 w-4 cursor-pointer rounded border-ink-300 text-brand-600 focus:ring-brand-500 disabled:cursor-not-allowed disabled:opacity-40" data-id="element-412" data-mp="3etk406xm6svt" />;
}
interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}
export function Pagination({
  page,
  totalPages,
  onChange
}: PaginationProps) {
  const pages = Array.from({
    length: totalPages
  }, (_, i) => i + 1);
  return <nav className="mt-auto flex items-center gap-1 pt-6 text-[13px]" aria-label="Pagination" data-id="element-413" data-mp="p88tv2qvxp08">
      <button type="button" onClick={() => onChange(Math.max(1, page - 1))} disabled={page === 1} className="flex items-center gap-1 rounded px-2 py-1 text-ink-500 hover:bg-ink-100 disabled:text-ink-300 disabled:hover:bg-transparent" data-id="element-414" data-mp="pa3dmdqf7b2q">
        <span aria-hidden="true" data-id="element-415" data-mp="7z7lm338yb0w">‹</span> Prev
      </button>
      {pages.map(n => <button key={n} type="button" onClick={() => onChange(n)} aria-current={n === page ? 'page' : undefined} className={`flex h-7 w-7 items-center justify-center rounded font-medium ${n === page ? 'bg-brand-600 text-white' : 'text-ink-600 hover:bg-ink-100'}`} data-id="element-416" data-mp="31ei5htbvv4b">
          {n}
        </button>)}
      <button type="button" onClick={() => onChange(Math.min(totalPages, page + 1))} disabled={page === totalPages} className="flex items-center gap-1 rounded px-2 py-1 text-ink-500 hover:bg-ink-100 disabled:text-ink-300 disabled:hover:bg-transparent" data-id="element-417" data-mp="lpjgg9r7unvq">
        Next <span aria-hidden="true" data-id="element-418" data-mp="32frnvnsxn2gm">›</span>
      </button>
    </nav>;
}
export function TableSkeleton({
  columns,
  rows = 6
}: {
  columns: number;
  rows?: number;
}) {
  return <tbody data-id="element-419" data-mp="1ojgmdu4uf9sl">
      {Array.from({
      length: rows
    }).map((_, r) => <tr key={r} className="border-b border-ink-200" data-id="element-420" data-mp="1olb5r40gutuk" data-mpi={r}>
          {Array.from({
        length: columns
      }).map((__, c) => <td key={c} className="border-r border-ink-200 px-4 py-3 last:border-r-0" data-id="element-421" data-mp="1yhe92d720yj3" data-mpi={c}>
              <span className="block h-3 w-full max-w-[140px] animate-pulse rounded bg-ink-200" data-id="element-422" data-mp="22ipzgkxr5nsc" />
            </td>)}
        </tr>)}
    </tbody>;
}